export default "__VITE_ASSET__B_F2CXMJ__"